// extracted by mini-css-extract-plugin
export default {"document":"PdfViewer_document__QTkCJ","rubricaePdfjsViewer":"PdfViewer_rubricaePdfjsViewer__GcoWW"};